import { STUDENT_CERTIFICATES } from '../../api/endpoints';
import request from '../../api/request';
import { CertificateType, ReportType } from './types';

/**
 * Pide la lista de reportes disponibles para descargar
 * @returns
 */

export function getAllCertificates(studyPlanEnrollmentId: number) {
  const url = STUDENT_CERTIFICATES.GET_ALL;
  return request<CertificateType[]>(url, {
    params: {
      studyPlanEnrollmentId,
    },
  });
}

/**
 * Descarga el archivo de reporte del url especificado
 * @param reportType El trozo final del endpoint que identifica de donde se decarga el documnento
 * @returns
 */
export const downloadCertificate = (
  studyPlanEnrollmentId: string | number,
  reportType: ReportType,
) => {
  const url = STUDENT_CERTIFICATES.DOWNLOAD_BY_URL(
    studyPlanEnrollmentId,
    reportType,
  );
  return request(url, {
    method: 'POST',
    data: {},
  });
};

/**
 * Genera un certificado con campos dinámicos
 * @param studyPlanEnrollmentId El ID de la inscripción del estudiante
 * @param reportType El tipo de certificado a generar
 * @param customFields Los campos personalizados del formulario dinámico
 * @returns
 */
export const generateCertificateWithCustomFields = (
  studyPlanEnrollmentId: string | number,
  reportType: ReportType,
  customFields: Record<string, any>,
) => {
  const url = STUDENT_CERTIFICATES.DOWNLOAD_BY_URL(
    studyPlanEnrollmentId,
    reportType,
  );
  return request(url, {
    method: 'POST',
    data: {
      customFields,
    },
  });
};
